import React, { useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBox';
import CheckBoxComponent from '../../../../SharedModules/CheckBox/CheckBox';
import {
  getCommonDropdownList,
  saveExcludedNDCsSearch,
  updateAllLabelerList,
  saveExcludedNDCsTableList,
  setExNDCsExtraState,
  saveExcludedNDCsErrorMsgList,
  saveExcludedNDCsSearchTable,
  updateFetchedNDCsValue,
  getModalCodeTableDetails,
  excludedNDCsModalSearchTableList,
  dispatchAllLabelerList,
  dispatchExcludedNDCsSearch,
} from '../store/actions';
import SearchExcludedNDCs from './gridComponents/ExNDCsGrid';
import { REBATE_SELECT } from '../../../../SharedModules/Errors/constantMessageData';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const filterList = [
  {
    field: 'planType',
    name: 'Plan Type',
    viewType: 'Radio',
    isEmp: true,
    list: [
      { name: 'Medicaid', value: 'FD' },
      { name: 'State', value: 'ST' },
    ],
  },
  {
    field: 'selection',
    name: 'Selection',
    viewType: 'Radio',
    isEmp: true,
    list: [
      { name: 'Existing Rows', value: 'Existing Rows' },
      { name: 'Any Rows', value: 'Any Rows' },
    ],
  },
  {
    field: 'rebateProgram',
    name: 'Rebate Program',
    viewType: 'SelectBox',
    isEmp: true,
    list: [],
  },
  {
    field: 'chooseBy',
    name: 'Choose By',
    viewType: 'Radio',
    isEmp: true,
    list: [
      { name: 'NDC', value: 'NDC' },
      { name: 'Labeler', value: 'Labeler' },
    ],
  },
  {
    field: 'selectBy',
    name: 'Select By',
    viewType: 'Radio',
    isEmp: true,
    list: [
      { name: 'NDC', value: 'NDC' },
      { name: 'Name', value: 'Name' },
      { name: 'Labeler', value: 'Labeler' },
    ],
  },
];

function ExcludedNDCsSearch(props) {
  const { viewFilter, pageFor = 'searchPage' } = props;
  const dispatch = useDispatch();
  // const getRebateProgramList = useSelector(
  //   (state) => state.sharedState.ExcludedNDCsReducer.dropdown
  // );
  const getSearchValue = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.searchValue
  );
  const allErrorMessages = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.errorMessages
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.errorMessages.serachPage
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const getNDCsTableList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsList
  );
  const getNDCsModalTableList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsListForModal
  );
  const extraState = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.ExcludedNDCsReducer.extraState.fullScreenView.labeler
  );
  const fullScreenViewForNDCLeft = useSelector(
    (state) =>
      state.sharedState.ExcludedNDCsReducer.extraState.fullScreenView
        .ndcLeftList
  );
  const fullScreenViewForNDCRight = useSelector(
    (state) =>
      state.sharedState.ExcludedNDCsReducer.extraState.fullScreenView
        .ndcRightList
  );
  const fullScreenViewTable = useSelector(
    (state) =>
      state.sharedState.ExcludedNDCsReducer.extraState.fullScreenView.tableName
  );
  const getSearchValueTable = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.searchTable
  );

  const setFilterValueTableAction = (value) =>
    dispatch(saveExcludedNDCsSearchTable(value));
  const setState = (value) => dispatch(setExNDCsExtraState(value));
  const setNDCsTableListAction = (value) =>
    dispatch(saveExcludedNDCsTableList(value));
  // const getFetchCommonDropdownList = (value) =>
  //   dispatch(getCommonDropdownList(value));
  const setFilterValueAction = (value) =>
    dispatch(saveExcludedNDCsSearch(value));
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rebateProList, setRebateProList] = useState([]);
  const [filterValue, setFilterValue] = useState({
    planType: 'FD',
    selection: 'Existing Rows',
    rebateProgram: '-1',
    chooseBy: 'NDC',
    selectBy: 'Labeler',
    allManufacturers: true,
    labeler: [],
    drugName: [],
    ndcs: [],
    manufacturers: [],
  });
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  const setStateChange = (val) => {
    setState({
      ...extraState,
      ...val,
    });
  };

  const callRebatePrograms = useCallback((pTy) => {
    if (pTy) {
      setLoading(true);
      dispatch(updateAllLabelerList({}));
      getCommonDropdownList(pTy)
        .then((res) => {
          setLoading(false);
          setRebateProList(res);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, []);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  React.useEffect(() => {
    if (getSearchValue?.planType) callRebatePrograms(getSearchValue?.planType);
  }, [getSearchValue?.planType]);

  React.useEffect(() => {
    if (pageFor === 'detailFilter' && extraState?.serachValForModal) {
      // await Promise.resolve();
      // setTimeout(() => {
        setStateChange({
          searchValueChange: true,
          serachValForModal: false,
        });
      // }, 3000);
    }
  }, [pageFor,extraState?.serachValForModal]);

  React.useEffect(() => {
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => {
        return x.navTo === '/excludedNDCs' && x.isRefresh;
      }).length > 0
    ) {
      const newObj = localStore.map((item) => {
        if (item.navTo === '/excludedNDCs') {
          item.isRefresh = false;
        }
        return item;
      });
      setNDCsTableListAction({
        ndcsLeft: [],
        ndcsRight: [],
      });
      dispatch(
        excludedNDCsModalSearchTableList({
          ndcsLeft: [],
          ndcsRight: [],
        })
      );

      dispatch(updateFetchedNDCsValue([]));
      dispatch(getModalCodeTableDetails([]));
      setFilterValueTableAction({
        ...getSearchValueTable,
        labeler: [],
        drugName: [],
        ndcs: [],
        ndcsLeft: [],
        ndcsRight: [],
        manufacturer: [],
        manufacturers: [],
        ndcsFilter: null,
        nameFilter: null,
        listFor: null,
        list: [],
      });
      setStateChange({ callLebelerAPI: true });
      let newData = {
        ...getSearchValue,
        planType: 'FD',
        selection: 'Existing Rows',
        rebateProgram: '-1',
        chooseBy: 'NDC',
        selectBy: 'Labeler',
        allManufacturers: true,
      };
      if (
        userDefaults &&
        !_.isEmpty(userDefaults) &&
        _.isEmpty(getSearchValue)
      ) {
        newData = {
          ...getSearchValue,
          planType:
            userDefaults.planTypeCd && _.isEmpty(getSearchValue)
              ? userDefaults.planTypeCd
              : 'FD',
          selection:
            userDefaults.selection && _.isEmpty(getSearchValue)
              ? userDefaults.selection
              : 'Existing Rows',
          rebateProgram: _.isEmpty(getSearchValue)
            ? userDefaults.rebateProgramCd
              ? userDefaults.rebateProgramCd
              : '-1'
            : getSearchValue.rebateProgram,
          chooseBy: _.isEmpty(getSearchValue)
            ? userDefaults.chooseBy
              ? userDefaults.chooseBy !== 'NDC'
                ? _.capitalize(userDefaults.chooseBy)
                : userDefaults.chooseBy
              : 'NDC'
            : getSearchValue.chooseBy,
          selectBy: _.isEmpty(getSearchValue)
            ? userDefaults.defNdcSelectModeCd
              ? userDefaults.defNdcSelectModeCd !== 'NDC'
                ? _.capitalize(userDefaults.defNdcSelectModeCd)
                : userDefaults.defNdcSelectModeCd
              : 'Labeler'
            : getSearchValue.selectBy,
          allManufacturers: _.isEmpty(getSearchValue)
            ? userDefaults.allManufacturers || true
            : getSearchValue.allManufacturers,
        };
      }
      callRebatePrograms(newData.planType);
      setFilterValueAction(newData);
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [localStore, userDefaults]);

  React.useEffect(() => {
    const updateTabs = localStore;
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/excludedNDCs') {
          if (errorMessages && errorMessages.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  const fetchSearchFilterValue = useCallback(() => {
    setLoading(false);
    setStateChange({ callLebelerAPI: true });
    setFilterValue({ ...getSearchValue });
  }, [getSearchValue]);

  React.useEffect(() => {
    fetchSearchFilterValue();
  }, [getSearchValue]);

  React.useEffect(() => {
    let list = [];
    setLoading(false);
    if (!_.isEmpty(rebateProList)) {
      if (
        rebateProList.status === '001' &&
        rebateProList.message === 'SUCESS'
      ) {
        if (!_.isEmpty(rebateProList.data)) {
          list = _.map(rebateProList.data, (val, ind) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
          if (getSearchValue.rebateProgram === '-1') {
            let rebateProgramCd = _.isEmpty(list) ? '-1' : list[0].id;
            if (userDefaults) {
              if (userDefaults.rebateProgramCd) {
                const checkD = !_.isEmpty(list)
                  ? _.filter(list, (l) => l.id === userDefaults.rebateProgramCd)
                  : [];
                rebateProgramCd =
                  getSearchValue.rebateProgram !== '-1'
                    ? getSearchValue.rebateProgram
                    : !_.isEmpty(checkD)
                    ? userDefaults.rebateProgramCd
                    : rebateProgramCd;
              }
            }
            setFilterValueAction({
              ...getSearchValue,
              rebateProgram: rebateProgramCd,
            });
          }
        }
      }
    }
    setRebateProgramList(list);
  }, [rebateProList]);

  const filterAction = useCallback(
    (flType, value) => {
      const newFilterVal = getSearchValue;
      let errMsg = _.cloneDeep(errorMessages);
      newFilterVal[flType] = value;

      if (flType === 'selection' || flType === 'chooseBy') {
        newFilterVal.chooseBy = flType === 'chooseBy' ? value : 'NDC';
        newFilterVal.selectBy = 'NDC';
        newFilterVal.allManufacturers = true;
        newFilterVal.labeler = [];
        newFilterVal.drugName = [];
        newFilterVal.ndcs = [];
        newFilterVal.manufacturers = [];
        const request = { ...getSearchValueTable };
        request.nameFilter = '';
        request.ndcsFilter = '';
        request.ndcsLeft = [];
        request.ndcsRight = [];
        dispatch(saveExcludedNDCsSearchTable(request));
        dispatch(dispatchAllLabelerList([]));
        dispatch(
          dispatchExcludedNDCsSearch({
            ...getSearchValue,
            selectRow: {},
          })
        );
      }
      if (flType === 'planType') {
        callRebatePrograms(value);
        errMsg = [];
        newFilterVal.rebateProgram = '-1';
      }
      if (flType === 'rebateProgram') {
        errMsg = !newFilterVal.rebateProgram ? [REBATE_SELECT] : [];
      }
      setStateChange({ callLebelerAPI: true });
      if (flType === 'selection') {
        setNDCsTableListAction({
          ...getNDCsTableList,
          ndcsLeft: [],
          ndcsRight: [],
        });
        dispatch(
          excludedNDCsModalSearchTableList({
            ...getNDCsModalTableList,
            ndcsLeft: [],
            ndcsRight: [],
          })
        );
      } else {
        setNDCsTableListAction({
          ...getNDCsTableList,
          ndcsLeft: [],
        });
        dispatch(
          excludedNDCsModalSearchTableList({
            ...getNDCsModalTableList,
            ndcsLeft: [],
          })
        );
      }
      setFilterValueAction(newFilterVal);
      fetchSearchFilterValue();
      dispatch(
        saveExcludedNDCsErrorMsgList({
          ...allErrorMessages,
          serachPage: errMsg || [],
        })
      );
    },
    [getSearchValue, getNDCsTableList, allErrorMessages]
  );

  const changeFullScreenView = (tableName) => {
    const dataSet = _.cloneDeep(extraState.fullScreenView);
    if (tableName === 'ndcLeftList') {
      const view = !fullScreenViewForNDCLeft;
      dataSet.ndcLeftList = view;
      dataSet.tableName = view ? tableName : null;
    } else if (tableName === 'ndcRightList') {
      const view = !fullScreenViewForNDCRight;
      dataSet.ndcRightList = view;
      dataSet.tableName = view ? tableName : null;
    } else {
      const view = !fullScreenView;
      dataSet.labeler = view;
      dataSet.tableName = view ? tableName : null;
    }
    setStateChange({ fullScreenView: dataSet });
  };

  return (
    <div
      className="excludedNDCs tBillPanel padding-0 "
      data-testid="excludedNDCs-search-component"
    >
      <Spinner load={pageFor === 'detailFilter' ? false : loading} />
      <div className="tabs-container">
        {pageFor !== 'detailFilter' &&
          (!fullScreenView ||
            !fullScreenViewForNDCLeft ||
            !fullScreenViewForNDCRight) && (
            <CustomSeparator parent1="Maintain" parent2="Excluded NDCs" />
          )}
        <DisplayErrorMessages errorMessages={errorMessages || []} />
        {!fullScreenView &&
          !fullScreenViewForNDCLeft &&
          !fullScreenViewForNDCRight && (
            <div className="no-margin">
              <div className="row mb-2">
                {!_.isEmpty(filterList)
                  ? filterList.map(
                      (val, ind) =>
                        !_.includes(viewFilter, val.field) && (
                          <div
                            className={
                              val.field === 'selectBy'
                                ? 'col-8 mb-3'
                                : 'col-4 mb-3'
                            }
                            key={val.field}
                            style={{
                              display:
                                val.field === 'selectBy'
                                  ? filterValue.chooseBy !== 'Labeler'
                                    ? 'block'
                                    : 'none'
                                  : val.field === 'chooseBy'
                                  ? filterValue.selection === 'Any Rows'
                                    ? 'none'
                                    : 'block'
                                  : 'block',
                            }}
                          >
                            {val.viewType === 'SelectBox' ? (
                              <SelectBoxComponent
                                data-testid={`${_.kebabCase(
                                  val.field
                                )}-select-box`}
                                labelName={_.startCase(val.field)}
                                required={val.isEmp}
                                reqColor
                                showSelectOne
                                placeholder="Please Select One"
                                optionList={rebateProgramList || []}
                                defaultValue={filterValue[val.field]}
                                filterAction={(e) => filterAction(val.field, e)}
                              />
                            ) : (
                              <RadioGroupComponent
                                data-testid={`${_.kebabCase(
                                  val.field
                                )}-redio-btn`}
                                id="radio-btn-action"
                                labelName={_.startCase(val.field)}
                                required={val.isEmp}
                                reqColor
                                optionList={val.list || []}
                                defaultValue={filterValue[val.field]}
                                filterAction={(e) => filterAction(val.field, e)}
                              />
                            )}
                          </div>
                        )
                    )
                  : null}
                {pageFor !== 'detailFilter' &&
                  filterValue.chooseBy === 'Labeler' &&
                  filterValue.selection === 'Existing Rows' && (
                    <div className="col-8">
                      <CheckBoxComponent
                        data-testid="all-manufacturers-check"
                        labelName="All Manufacturers"
                        defaultValue={filterValue.allManufacturers}
                        filterAction={(e) =>
                          filterAction(
                            'allManufacturers',
                            !filterValue.allManufacturers
                          )
                        }
                      />
                    </div>
                  )}
              </div>
            </div>
          )}

        <div data-testid="call-search-excluded-ndcs-table-area">
          <SearchExcludedNDCs
            data-testid="call-search-excluded-ndcs-table"
            fullScreenView={fullScreenView}
            fullScreenViewForNDCLeft={fullScreenViewForNDCLeft}
            fullScreenViewForNDCRight={fullScreenViewForNDCRight}
            setFullScreenView={(list) => changeFullScreenView(list)}
            filterValue={filterValue}
            viewFilter={viewFilter}
            setLoading={setLoading}
            fullScreenViewTable={fullScreenViewTable}
            {...props}
          />
        </div>
      </div>
    </div>
  );
}
export default withRouter(ExcludedNDCsSearch);
